module.exports = __webpack_public_path__ + "static/img2-65577f6e3dbdc292191e9ebb68149b4b.png";